import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import React, { useEffect } from "react";

const ExpressCheckoutElement = ({onStripeReady, setIsCardSelected}) => {
  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    if(stripe &&  elements){
      onStripeReady({stripe, elements});
    }
  }, [stripe, elements, onStripeReady])

  const handleChange = (e) => {
    console.log(e)
    if(e.value?.type === "card"){
      setIsCardSelected(true);
    }else{
      setIsCardSelected(false);
    }
  }

  return (
    <form className="w-[100%] p-2 pt-0">
      <PaymentElement 
        onChange={handleChange} 
        className="w-[100%]"
      />
    </form>
  );
};

export default ExpressCheckoutElement;
